import { NodeTimeDependentState } from "./states/TimeDependent";
import { NodeErrorState } from "./states/Error";
export class NodeStatesController {
  constructor(node) {
    this.node = node;
    this.timeDependent = new NodeTimeDependentState(this.node);
    this.error = new NodeErrorState(this.node);
  }
}
